import React, { Component } from "react";
import PropTypes from "prop-types";

import backend from "utils/backend";
import { FETCH_STATUS } from "config/constants";

class FetchOnSubmit extends Component {
  constructor(props) {
    super(props);

    this.reset = this._reset.bind(this);
    this.submit = this._submit.bind(this);

    this.state = { status: FETCH_STATUS.READY, error: null };
  }

  _reset() {
    this.setState({ status: FETCH_STATUS.READY, error: null });
  }

  _submit(data) {
    this.setState({ status: FETCH_STATUS.LOADING });

    return backend
      .request({
        method: this.props.method,
        url: this.props.url,
        data,
      })
      .then(() => {
        this.setState({ status: FETCH_STATUS.SUCCESS });
      })
      .catch(error => {
        this.setState({
          status: FETCH_STATUS.ERROR,
          error: error || new Error("Something went wrong, please try again."),
        });
      });
  }

  render() {
    return this.props.children({
      status: this.state.status,
      error: this.state.error,
      submit: this.submit,
      reset: this.reset,
    });
  }
}

FetchOnSubmit.propTypes = {
  url: PropTypes.string.isRequired,
  method: PropTypes.string.isRequired,
};

export default FetchOnSubmit;
